import { HanAccountColumns } from '@/backend/features/health-alerts/entities/Account';
import { AccountFilterParams, useAccountFilter } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountFilter';
import { AccountFilterData } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountList';
import { useOverrideMapCredentialingAccountFilter } from '@juvare/credentialing/ui/hooks';
import { Filter } from '@juvare/platform-shared/features/storage';

export function useOverrideMapAccountFilter() {
    const useOverrideAccountFilter = (
        params: AccountFilterParams,
    ): {
        data?: Filter<HanAccountColumns>[];
        isLoading: boolean;
        error?: unknown;
    } => {
        const { data: accountData, error: accountError, isLoading: accountLoading } = useAccountFilter(params);

        const { useOverrideCredentialingAccountFilter } = useOverrideMapCredentialingAccountFilter();

        const {
            data: credentialingData,
            error: credentialingError,
            isLoading: credentialingLoading,
        } = useOverrideCredentialingAccountFilter(params);

        if (accountLoading || credentialingLoading) {
            return { data: undefined, isLoading: true, error: undefined };
        }

        if (accountError || credentialingError) {
            return { data: undefined, isLoading: false, error: accountError || credentialingError };
        }

        let combinedData: Filter<HanAccountColumns>[] = [...((accountData ?? []) as Filter<HanAccountColumns>[])];

        const filterData = params.filterData as ExtendedAccountFilterData;
        if (filterData?.hanRoles) {
            combinedData.push({ column: 'hanRoles', op: 'overlap', value: filterData.hanRoles });
        }
        if (filterData?.outsideState) {
            combinedData.push({ column: 'outsideState', op: '=', value: filterData.outsideState });
        }

        combinedData = [...combinedData, ...((credentialingData ?? []) as Filter<HanAccountColumns>[])];

        return { data: combinedData, isLoading: false };
    };

    return { useOverrideAccountFilter };
}

export interface ExtendedAccountFilterData extends AccountFilterData {
    hanRoles?: string[];
    outsideState?: boolean;
}
